import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetEdit } from '../../../../shared/components/widget-edit/widget-edit';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ModalService } from '../../../../shared/services/modal.service';

@Component({
  selector: 'app-investment-value-widget',
  standalone: true,
  imports: [CommonModule, WidgetEdit, CdkOverlayOrigin],
  templateUrl: './investment-value.html',
  styleUrls: ['./investment-value.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvestmentValue {
  @Input() title = 'INVESTMENT VALUE';
  @Input() size: 'small' | 'medium' | 'half' | 'full' = 'medium';
  @Input() index = 0;
  @Input() isEditMode = false;
  @Input() isAddMode = false;
  @Output() addWidget = new EventEmitter<void>();
  @Input() activeDropdownIndex: number | null = null;
  @Input() getAvailableSizes!: (index: number) => Array<{ value: string; label: string }>;
  @Input() toggleSizeDropdown!: (index: number, event: Event) => void;
  @Input() changeWidgetSize!: (index: number, size: any) => void;
  @Input() removeWidget!: (index: number) => void;

  // Example / placeholder data — replace with real inputs/service
  portfolioValue = 125500;
  lastUpdated = '4 JUNE 2026';
  holdings = [
    { name: 'Apple Inc. (AAPL)', value: '600,54' },
    { name: 'Tesla (NASDAQ: TSLA)', value: '402,52' }
  ];

  constructor(private modalService: ModalService) {}

  openModal() {
    if (!this.isEditMode && !this.isAddMode) {
      // this.modalService.openInvestmentModal?.() || console.log('Open investment modal');
    }
  }
}